import { createFileRoute } from '@tanstack/react-router'

import ProvinceDetailPage from '@/components/pages/guest/_ext-intitutions/containers/details/province'

export const Route = createFileRoute(
  '/_guest/guest/extensions-institutions/province/$id'
)({
  component: RouteComponent
})

function RouteComponent() {
  const { id } = Route.useParams()

  return <ProvinceDetailPage provinceId={id} />
}
